import AttendAllowancePage from './AttendAllowancePage';

export default AttendAllowancePage;
